import React from 'react';
import Background from './Background'; // Pfad überprüfen!
import LinkElement from './Link'; // Einheitlich wie im Header

const Footer = ({ Background: backgroundData, Link: linkItems }) => {
  return (
    <footer className="position-relative bg-dark text-white p-4 d-flex flex-column justify-content-center align-items-center overflow-hidden"
            style={{ marginTop: '00px' }}> {/* Stelle sicher, dass der margin-top hier ist */}
      {/* Hintergrund des Footers */}
      <Background {...backgroundData} />

      {/* Inhalt des Footers */}
      <div className="position-relative z-index-1 w-100 text-center">
        {linkItems && linkItems.length > 0 ? (
          <nav className="footer-nav mb-3">
            <ul className="d-flex flex-wrap justify-content-center gap-3 list-unstyled mb-0">
              {linkItems.map((link) => (
                <li key={link.id}>
                  <LinkElement {...link} />
                </li>
              ))}
            </ul>
          </nav>
        ) : (
          <p className="text-secondary">Keine Links im Footer vorhanden.</p>
        )}

        <p className="small text-secondary mb-0">
          &copy; {new Date().getFullYear()} Deine Webseite. Alle Rechte vorbehalten.
        </p>
      </div>
    </footer>
  );
};

export default Footer;